import api from "../request";
import { Promise } from "q";

function getExternalQuestionsList(reqData) {
  return api.post(`questions/get-external-question-list`, { reqData }).then(({ data }) => {
    return data;
  });
}

function editExternalQuestion(reqData) {
  return api.post(`questions/external-question-update`, { reqData }).then(({ data }) => {
    return data;
  });
}

function publishQuestionsToMasterDb(reqData) {
  return api.post(`questions/external-publish-questions`, { reqData }).then(({ data }) => {
    return data;
  });
}

export default {
    getExternalQuestionsList,
    editExternalQuestion,
    publishQuestionsToMasterDb,
};
